// extracted by mini-css-extract-plugin
export default {"tagStyle":"styles_tagStyle__fkSEi","input":"styles_input__w1i1w"};